import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent, IConfirmDialog } from '@shared/components/confirm-dialog/confirm-dialog.component';
import { map, take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ISelectItems } from '@shared/models/selectItems';
import { ILab } from 'app/models/lab-user-menu/lab';
import { ILabApplication } from 'app/models/application-menu/lab-application';


const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
  }),
};

@Injectable({ providedIn: 'root' })
export class SharedService {

  // private api: string = environment.privateApi + "ApplicationMenu/";
  private mainApi: string = environment.privateApi + "MainMenu/";

  public mobile: boolean = false;
  public tablet: boolean = false;
  public development: boolean = environment.build === 'Development';
  private api: string = environment.privateApi;
  private appApi: string = environment.privateApi + "ApplicationMenu/";
  private changeTheme: Subject<string> = new Subject<string>();
  public darkMode: boolean = false;
  public theme: string = 'light';
  public countyAccess: string[] = []

  public states: string[] = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL",
    "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT",
    "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI",
    "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];
  /**
   * Color Codes
   */
  public purple: string = '#9355dc';
  public blue: string = '#628ef4';
  public gold: string = '#ffbe2e';
  public green: string = '#70e17b';
  public pink: string = '#e9695f';
  public orange: string = '#EC891D';
  public red: string = '#fc4132';
  public loading: boolean = false;
  public today: Date = new Date(Date.now());

  /**
   * License Types
   */

  public userCountyList: ISelectItems[] = []
  /*
   * Statuses
   */
  public started: string = "Started";
  public submitted: string = "Submitted";
  public submittedForApproval: string = 'Submitted for Approval';
  public resubmitted: string = "Resubmitted";
  public awaitingPayment: string = "Approved, Pending Payment and Clearance";
  public approved: string = "Approved";
  public incomplete: string = "Incomplete";
  public insufficient: string = "Insufficient";
  public underReview: string = "Under Review";
  public denied: string = "Denied";
  public revoked: string = "Revoked";
  public expired: string = "Expired";
  public withdrawn: string = "Withdrawn";
  public surrendered: string = "Surrendered";
  public closed: string = 'Closed';

  currentLab: ILab;
  currentTab: number = 0;
  currentApplication: ILabApplication;

  currentLabId: number = 0;
  currentLabName: string = "";
  currentOrelapId: string = "";
  readonlyApplication: boolean = true;
  loginFailed: boolean = false;
  currentPt: number = 0;


  // loremIpsum: string = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
  // incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
  // laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
  // esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt
  // in culpa qui officia deserunt mollit anim id est laborum.`

  constructor(
    private http: HttpClient,
    private router: Router
  ) { }

  public confirmDialogRef: MatDialogRef<ConfirmDialogComponent>;

  private httpClient = inject(HttpClient);
  public dialog = inject(MatDialog);
  public toastr = inject(ToastrService);

  public openNotice(message: string): void {
    let data: IConfirmDialog = {
      message: message,
      confirmation: false
    }
    this.openDialog(data);
  }

  public openConfirm(message: string): void {
    let data: IConfirmDialog = {
      message: message,
      confirmation: true
    }
    this.openDialog(data);
  }

  openDialog(data: IConfirmDialog): void {
    this.confirmDialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: data,
      role: 'dialog',
      ariaLabel: "Confirmation Dialog",
      minWidth: '300px',
      maxWidth: !this.mobile ? '700px' : '300px',
      maxHeight: this.mobile ? '600px' : '700px',
      panelClass: this.theme === "dark" ? "theme-dark" : "",
    });
  }

  public confirmed(): Observable<any> {
    return this.confirmDialogRef.afterClosed().pipe(take(1), map(response => {
      return response;
    }));
  }

  public downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  public downloadFile2(blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.click();
  }

  public downloadCSV(csvContent: string, fileName: string) {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', fileName);
    a.style.display = 'none';
    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  get isMobile(): boolean {
    return this.mobile;
  }

  submitAndLockApplication(): Observable<any> {
    return this.http.post(
      this.appApi + "submitAndLock",
      this.currentApplication,
      httpOptions
    );
  }

  themeChanged$ = this.changeTheme.asObservable();

  getUserTheme(): void {
    this.httpClient.get<string>(this.api + "UserProfile/GetUserTheme", { responseType: 'text' as 'json' }).subscribe({
      next: response => {
        this.theme = response;
        this.toggleTheme();
      },
      error: e => console.log('error getting user theme', e)
    });
  }

  updateUserTheme(): void {
    this.httpClient.post<any>(this.api + "UserProfile/UpdateUserTheme/" + this.theme, null).subscribe(
      () => { },
      error => console.log('error', error)
    );
  }

  toggleTheme() {
    this.darkMode = this.theme === 'dark';
    this.changeTheme.next(this.theme);
  }

  consoleLog(error: any): void {
    if (this.development) {
      console.log('error', error);
    }
  }

  isCancelled(response: any): boolean {
    return response === 'cancel' || response === null || response === '' || response === undefined;
  }


  doRedirect(url: string) {
    this.router.navigateByUrl(url);
  }

  downloadHelpFile(type: string): Observable<Blob> {
    // return this.http.get<Blob>(environment.publicApi + 'Account/' + 'downloadHelpFile/' + type + '/PDF', { responseType: 'blob' as 'json' });
    return this.http.get<Blob>(this.mainApi + 'downloadHelpFile/' + type + '/PDF', { responseType: 'blob' as 'json' });
  }
}

